/**
 * Fragment de routes du paquet v9-p04-exceptions (vague V9 ; fragment `v9-<sous>` par paquet, constat K11 de la fiche
 * V9). Composants chargés à la demande (règle de chargement du registre). Routes neuves :
 *  - `/org/abonnement/exceptions/nouvelle` → dialogue-demander-exception-facturation ;
 *  - `/org/abonnement/exceptions/:demandeId` → organisation-demande-exception-fiche ;
 *  - `/plateforme/organisations/:organisationId/exceptions/nouvelle` → dialogue-exception-facturation ;
 *  - `/plateforme/exceptions/:exceptionId` → plateforme-exception-facturation-fiche.
 * Les écrans de plateforme reçoivent `superAdmin` (rôle de plateforme de la session) : le contexte de la règle de
 * plateforme en dépend, comme le résolveur de plateforme de la passerelle.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const DialogueDemanderExceptionFacturation = lazy(() => import('../ecrans/v9/exceptions/DialogueDemanderExceptionFacturation'))
const OrganisationDemandeExceptionFiche = lazy(() => import('../ecrans/v9/exceptions/OrganisationDemandeExceptionFiche'))
const DialogueExceptionFacturation = lazy(() => import('../ecrans/v9/exceptions/DialogueExceptionFacturation'))
const PlateformeExceptionFacturationFiche = lazy(() => import('../ecrans/v9/exceptions/PlateformeExceptionFacturationFiche'))

function ecran(Composant: ComponentType<{ session: Session; superAdmin?: boolean }>) {
  return ({ session, superAdmin, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} superAdmin={superAdmin} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v9-exceptions',
  routes: [
    { chemin: '/org/abonnement/exceptions/nouvelle', element: ecran(DialogueDemanderExceptionFacturation) },
    { chemin: '/org/abonnement/exceptions/:demandeId', element: ecran(OrganisationDemandeExceptionFiche) },
    { chemin: '/plateforme/organisations/:organisationId/exceptions/nouvelle', element: ecran(DialogueExceptionFacturation) },
    { chemin: '/plateforme/exceptions/:exceptionId', element: ecran(PlateformeExceptionFacturationFiche) },
  ],
}
